export default __webpack_public_path__ + "assets/haiti-flag.png";